export const MessageTypes = {
  QuickReplies: 'QuickReplies',
};
